<template>
  <div style="text-align: center;">
    <h5>学科竞赛查询</h5>

    <!-- 选择栏 -->
    <div style="margin-bottom: 20px;">
      <!-- 学期选择 -->
      <el-select
        v-model="selectedSemester"
        placeholder="请选择学期"
        style="width: 200px; margin-right: 10px;"
      >
        <el-option
          v-for="(item, index) in semesters"
          :key="item.uuid"
          :label="item.name"
          :value="item.uuid"
        >
          <span>{{ item.name }}</span>
          <template v-if="index === 0">
            <el-tag type="primary" style="margin-left: 8px;">当前</el-tag>
          </template>
        </el-option>
      </el-select>

      <!-- 获奖身份多选框 -->
      <el-select
        v-model="selectedIdentities"
        multiple
        collapse-tags
        placeholder="请选择获奖身份"
        style="width: 250px; margin-right: 10px;"
      >
        <el-option label="教师" value="教师" />
        <el-option label="学生" value="学生" />
        <el-option label="班级" value="班级" />
      </el-select>

      <!-- 操作按钮 -->
      <el-button type="primary" @click="fetchCompetitions">查询</el-button>
      <el-button type="success" @click="toggleEditMode" style="margin-left: 10px;">
        {{ editMode ? '退出修改模式' : '进入修改模式' }}
      </el-button>
      <el-button v-if="editMode" type="primary" @click="saveChanges" style="margin-left: 10px;">
        保存修改
      </el-button>
    </div>

    <!-- 表格 -->
    <el-table
      :data="competitions"
      border
      style="width: 98%; margin: 0 auto; text-align: left;"
    >
      <el-table-column prop="Winner" label="获奖者" width="120">
        <template #default="scope">
          <span>{{ scope.row.Winner }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="class" label="班级" width="120">
        <template #default="scope">
          <el-input
            v-if="editMode"
            v-model="scope.row.class"
            size="small"
          ></el-input>
          <span v-else>{{ scope.row.class }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="AwardName" label="奖项名称" min-width="200">
        <template #default="scope">
          <el-input
            v-if="editMode"
            v-model="scope.row.AwardName"
            size="small"
          ></el-input>
          <span v-else>{{ scope.row.AwardName }}</span>
        </template>
      </el-table-column>

      <!-- ✅ 新增：奖项等级（GradeName） -->
      <el-table-column prop="GradeName" label="奖项等级" width="150">
        <template #default="scope">
          <el-input
            v-if="editMode"
            v-model="scope.row.GradeName"
            size="small"
          ></el-input>
          <span v-else>{{ scope.row.GradeName }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="mentor" label="指导教师" width="150">
        <template #default="scope">
          <span>{{ scope.row.mentor || '—' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="type" label="身份" width="100">
        <template #default="scope">
          <el-select
            v-if="editMode"
            v-model="scope.row.type"
            size="small"
            style="width: 90px;"
          >
            <el-option label="教师" value="教师" />
            <el-option label="学生" value="学生" />
            <el-option label="班级" value="班级" />
          </el-select>
          <span v-else>{{ scope.row.type }}</span>
        </template>
      </el-table-column>

      <el-table-column label="上传日期" width="120">
        <template #default="scope">
          <span>{{ scope.row.up_year }}/{{ scope.row.up_month }}/{{ scope.row.up_day }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="180" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="downloadPDF(scope.row)">下载</el-button>
          <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页脚 -->
    <div style="margin-top: 30px; font-size: 14px; color: #666;">
      <p>2024-2025 起航工作室 © 版权所有</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  data() {
    return {
      semesters: [],
      selectedSemester: null,
      selectedIdentities: [],
      competitions: [],
      editMode: false,
    }
  },
  mounted() {
    this.fetchSemesters()
  },
  methods: {
    async fetchSemesters() {
      try {
        const res = await axios.get('/api/semesters')
        this.semesters = res.data.semesters
      } catch {
        ElMessage.error('获取学期列表失败')
      }
    },

    async fetchCompetitions() {
      if (!this.selectedSemester || this.selectedIdentities.length === 0) {
        ElMessage.warning('请选择学期和至少一个获奖身份')
        return
      }
      try {
        const res = await axios.get('/api/competition/list', {
          params: {
            semesterUuid: this.selectedSemester,
            identities: this.selectedIdentities.join(','),
          },
        })
        this.competitions = res.data.competitions
      } catch {
        ElMessage.error('获取竞赛信息失败')
      }
    },

    toggleEditMode() {
      this.editMode = !this.editMode
    },

    async saveChanges() {
      try {
        for (const item of this.competitions) {
          await axios.put('/api/competition/update', item)
        }
        ElMessage.success('修改已保存')
        this.editMode = false
        this.fetchCompetitions()
      } catch {
        ElMessage.error('保存失败')
      }
    },

    async confirmDelete(row) {
      try {
        await ElMessageBox.confirm(`确定要删除 "${row.Winner}" 的记录吗？`, '确认删除', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
        })
        await axios.delete(`/api/competition/delete/${row.uuid}`)
        ElMessage.success('删除成功')
        this.fetchCompetitions()
      } catch {
        ElMessage.info('已取消删除')
      }
    },

    async downloadPDF(row) {
      try {
        const response = await axios.post('/download/competition', row, {
          responseType: 'blob',
        })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${row.Winner}-竞赛证书.pdf`
        link.click()
      } catch {
        ElMessage.error('下载失败')
      }
    },
  },
}
</script>

<style scoped>
.el-table th,
.el-table td {
  text-align: center !important;
  vertical-align: middle !important;
}
</style>
